module.exports = __webpack_public_path__ + "../../static/vue/img/external_link.dd73ef33.svg";